<template>
  <div class="inner pd-top-block" id="dangki">
    <div class="banner-bottom-bg">
      <div class="banner-cover">
        <div class="banner-cover-inner">
          <h2 class="heading-02">Bạn đã sẵn sàng</h2>
          <p class="bot-p">Chuyên viên Rever Academy luôn sẵn sàng lắng nghe và hỗ trợ bạn mọi lúc</p>
          <a class="button1 openBtn" v-register-button id="signin">Đăng ký ngay</a>
        </div>
      </div>
    </div>
  </div>
</template>
